import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latestComics = [...comics]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 8);

  return (
    <section id="latest" className="py-16 md:py-20 bg-background-100" aria-labelledby="latest-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 id="latest-heading" className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">最新章节实时更新，追更快人一步</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {latestComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex gap-4 p-4 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="w-20 md:w-24 flex-shrink-0 rounded-lg overflow-hidden bg-background-100">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full aspect-[3/4] object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col justify-between min-w-0 flex-1">
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{comic.description}</p>
                </div>
                <div className="flex items-center gap-2 mt-2">
                  <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700">
                    {comic.status}
                  </span>
                  <span className="text-[10px] text-foreground-400">
                    更新至 {comic.chapters[0]?.title || '最新话'}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}